<template>
  <section id="39-fintech-highlighted-chil">
    <img
      style="width: 100%"
      src="@/assets/news/dailyfinance.png"
      alt="dailyfinance"
    />
    <p>
      {{ $t("content") }}
    </p>
    <a
      href="https://df.media/these-are-the-top-fintech-financial-technology-companies-in-chile-2021/"
    >
      ver mas
    </a>
    <br />
  </section>
</template>
<script>
export default {
  name: "fintech-highlighted-chile",
};
</script>
<i18n>
{
    "es": {
        "title": "Reconocida entre las 39 mejores Fintech en Chile en base a Innovación, crecimiento, administración, impacto social por Daily Finance",
        "content": "CEPTINEL RegTech fue elegida entre las Top 39 Fintech Chilenas con mejor rendimiento en 2021 por el medio inglés Daily Finance. El proceso incluía la búsqueda de los Fintechs con desempeño extraordinario, midiendo niveles de innovación, crecimiento, administración e impacto social. En Ceptinel, estamos muy orgullosos del reconocimiento como líderes en la industria financiera."
    },
    "en": {
        "title": "Ceptinel among the leading Fintech companies in Chile",
        "content": "CEPTINEL RegTech was chosen among the Top 39 Chilean Fintechs with the best performance in 2021 by the English media Daily Finance. The process included the search for Fintechs with extraordinary performance, measuring levels of innovation, growth, administration and social impact. We are very proud of being recognized as leaders in the financial industry."
    },
    "pt": {
        "title": "Reconhecida entre as 39 melhores Fintech do Chile com base em Inovação, crescimento, administração e impacto social pelo Daily Finance",
        "content": "CEPTINEL RegTech foi eleita entre as 39 melhores Fintech chilenas com melhor desempenho em 2021 pela mídia inglesa Daily Finance. O processo incluiu a busca por Fintechs com desempenho extraordinário, medindo os níveis de Inovação, Crescimento, Administração e Impacto Social. Na Ceptinel, temos muito orgulho de sermos reconhecidos como líderes no setor financeiro."
    }
}
</i18n>
